import { t } from "i18next";
import { useMemo } from "react";
import { UploadProgressItem } from "../UploadProgressToast";

/**
 * Obtiene el mensaje de estado principal basado en el conteo de uploads
 */
const getProcessingMessage = (count: number): string => {
	const filesKey =
		count === 1
			? t("catalogue.upload-progress.file-singular")
			: t("catalogue.upload-progress.files-plural");

	return t("catalogue.upload-progress.processing-count", {
		count,
		files: filesKey,
	});
};

/**
 * Obtiene el mensaje de error basado en el conteo
 */
const getErrorMessage = (count: number): string => {
	const errorsKey =
		count === 1
			? t("catalogue.upload-progress.error-singular")
			: t("catalogue.upload-progress.errors-plural");

	return t("catalogue.upload-progress.error-count", {
		count,
		errors: errorsKey,
	});
};

/**
 * Obtiene el mensaje de completados basado en el conteo
 */
const getCompletedMessage = (count: number): string => {
	const filesKey =
		count === 1
			? t("catalogue.upload-progress.file-completed-singular")
			: t("catalogue.upload-progress.files-completed-plural");

	return t("catalogue.upload-progress.completed-count", {
		count,
		files: filesKey,
	});
};

/**
 * Hook para obtener el mensaje de estado principal del toast
 */
export const useUploadStatusMessage = (
	activeUploads: UploadProgressItem[],
	completedCount: number,
	errorCount: number,
	isInSecondStep = false,
): string => {
	return useMemo(() => {
		if (activeUploads.length > 0) {
			return getProcessingMessage(activeUploads.length);
		}
		if (errorCount > 0) {
			return getErrorMessage(errorCount);
		}
		// Solo mostrar mensaje de completados si NO estamos en second-step
		if (completedCount > 0 && !isInSecondStep) {
			return getCompletedMessage(completedCount);
		}
		return t("catalogue.upload-progress.processing-files");
	}, [activeUploads.length, errorCount, completedCount, isInSecondStep]);
};
